var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M1472.08,122l6.92,6.818-6.92,6.818v-4.048a11.511,11.511,0,0,0-5.45.724A19.109,19.109,0,0,0,1461,137s1.27-5.346,4.15-8.182c2.65-2.609,6.93-2.727,6.93-2.727V122Z","transform":"translate(-1461 -122)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }